export const PAGE_CONTENT_ITEM_TYPE_AUTHOR_NAME = 'author_name';
export const PAGE_CONTENT_ITEM_TYPE_CAPTION_TEXT = 'caption_text';
export const PAGE_CONTENT_ITEM_TYPE_RECTANGLE = 'rectangle';
export const PAGE_CONTENT_ITEM_TYPE_TEXT_BOX = 'text_box';
export const PAGE_CONTENT_ITEM_TYPE_IMAGE = 'image';

export const WYSIWYG_EDITOR_ADD_PAGE_CONTENT_ITEM =
  'WYSIWYG_EDITOR_ADD_PAGE_CONTENT_ITEM';
export const WYSIWYG_EDITOR_DELETE_PAGE_CONTENT_ITEM =
  'WYSIWYG_EDITOR_DELETE_PAGE_CONTENT_ITEM';

export const WYSIWYG_EDITOR_MOVE_PAGE_CONTENT_ITEM_FORWARD =
  'WYSIWYG_EDITOR_MOVE_PAGE_CONTENT_ITEM_FORWARD';
export const WYSIWYG_EDITOR_MOVE_PAGE_CONTENT_ITEM_BACKWARD =
  'WYSIWYG_EDITOR_MOVE_PAGE_CONTENT_ITEM_BACKWARD';

export const WYSIWYG_EDITOR_SET_LAYOUT_TEMPLATE_NAME =
  'WYSIWYG_EDITOR_SET_LAYOUT_TEMPLATE_NAME';
export const WYSIWYG_EDITOR_SET_BACKGROUND_IMAGE_ID =
  'WYSIWYG_EDITOR_SET_BACKGROUND_IMAGE_ID';

export const WYSIWYG_EDITOR_UNDO = 'WYSIWYG_EDITOR_UNDO';
export const WYSIWYG_EDITOR_REDO = 'WYSIWYG_EDITOR_REDO';

export const WYSIWYG_EDITOR_UPDATE_CONTENT_ITEM_LOCATIONS =
  'WYSIWYG_EDITOR_UPDATE_CONTENT_ITEM_LOCATIONS';
export const WYSIWYG_EDITOR_UPDATE_CONTENT_ITEM_CONTAINER_LOCATION =
  'WYSIWYG_EDITOR_UPDATE_CONTENT_ITEM_CONTAINER_LOCATION';
export const WYSIWYG_EDITOR_UPDATE_CONTENT_ITEM_CONTENT_LOCATION =
  'WYSIWYG_EDITOR_UPDATE_CONTENT_ITEM_CONTENT_LOCATION';
export const WYSIWYG_EDITOR_UPDATE_PAGE_CONTENT_ITEM =
  'WYSIWYG_EDITOR_UPDATE_PAGE_CONTENT_ITEM';
export const WYSIWYG_EDITOR_UPDATE_IMAGE_PAGE_CONTENT_ITEM_ZOOM =
  'WYSIWYG_EDITOR_UPDATE_IMAGE_PAGE_CONTENT_ITEM_ZOOM';
export const WYSIWYG_EDITOR_UPDATE_TEXT_PAGE_CONTENT_ITEM_CONTENT =
  'WYSIWYG_EDITOR_UPDATE_TEXT_PAGE_CONTENT_ITEM_CONTENT';
export const WYSIWYG_EDITOR_UPDATE_TEXT_PAGE_CONTENT_ITEM_BACKGROUND_COLOR =
  'WYSIWYG_EDITOR_UPDATE_TEXT_PAGE_CONTENT_ITEM_BACKGROUND_COLOR';

export const WYSIWYG_EDITOR_REPLACE_PAGE_CONTENT_IMAGES =
  'WYSIWYG_EDITOR_REPLACE_PAGE_CONTENT_IMAGES';

export const WYSIWYG_EDITOR_TOOLBOX_TOGGLE_ACTIVE_TAB =
  'WYSIWYG_EDITOR_TOOLBOX_TOGGLE_ACTIVE_TAB';
export const WYSIWYG_EDITOR_TOOLBOX_CLOSE_DRAWER =
  'WYSIWYG_EDITOR_TOOLBOX_CLOSE_DRAWER';

export const WYSIWYG_EDITOR_SAVE_SNAPSHOT = 'WYSIWYG_EDITOR_SAVE_SNAPSHOT';

export const WYSIWYG_EDITOR_CLEAR_IMAGE = 'WYSIWYG_EDITOR_CLEAR_IMAGE';

export const WYSIWYG_EDITOR_TEXT_CACHE_ADD_ITEM =
  'WYSIWYG_EDITOR_TEXT_CACHE_ADD_ITEM';
export const WYSIWYG_EDITOR_TEXT_CACHE_REMOVE_ITEM =
  'WYSIWYG_EDITOR_TEXT_CACHE_REMOVE_ITEM';

export const WYSIWYG_EDITOR_MOVE_TEXT_CONTENT_TO_CACHE =
  'WYSIWYG_EDITOR_MOVE_TEXT_CONTENT_TO_CACHE';
